<script setup lang="ts">
import { computed } from 'vue'
import { useMission } from '~/composables/useMission'
import MissionInfos from '~/features/operations-nationales/components/tournee-ete/MissionInfos.vue'
// import MissionInfos from '~/features/operations-nationales/components/printemps-pour-la-planete/MissionInfos.vue'
import type { Mission } from '~/types/mission'

const props = defineProps({
  mission: {
    type: Object as () => Mission,
    required: true,
  },
})

const { hasTag } = useMission(props.mission)

const showMissionInfos = computed(() => {
  return hasTag("La tournée d'été")
})
</script>

<template>
  <div v-if="showMissionInfos">
    <MissionInfos />
  </div>
</template>
